// @ts-nocheck
/* eslint-disable */

"use client";

import {
  BlogCard,
  Button,
  Column,
  EmptyState,
  Heading,
  Icon,
  Loader,
  Row,
  Spacer,
} from "tempdev-ds";
import { Suspense, useState } from "react";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import Link from "next/link";
import { formatDate } from "@/lib/helpers/dateFormate";
import { useGlobalContext } from "@/lib/globalContext";

const Archive = (post: Record<string, unknown>) => {
  const [loading, setLoading] = useState<boolean | null>(false);

  const state = useGlobalContext();

  return (
    <>
      <div className="bg-primary30 pt-6 pb-6">
        <Row>
          <Column>
            <Button
              variant="link"
              href="/blog/"
              leftIcon={<Icon icon="icon-arrow-back"></Icon>}
            >{state?.dict?.custom?.backBlog}</Button>
            <Heading tag="h1" size="h4" className="mt-3">
              Results for: <span className="color-primary70">{post?.name}</span>
            </Heading>
          </Column>
        </Row>
      </div>
      <Spacer height={6} />
      <Row>
        {loading ? (
          <Column className="text-center pt-5 pb-5">
            <Loader label={state?.dict?.common?.loading}></Loader>
          </Column>
        ) : (
          <Suspense
            fallback={<Loader label={state?.dict?.common?.loading}></Loader>}
          >
            {post && post?.items?.length !== 0 ? (
              post?.items?.map(
                (post: Record<string, unknown>, i: number) => {
                  if (!post) return false;

                  const category =
                    (post?.categories as Record<string, unknown | string>) ||
                    [];
                  const categoryName =
                    category && category[0] ? (category[0].name as string) : "";
                  const imageElement = (
                    <DisplayImage
                      url={post?.image as string}
                      alt={post?.title ? (post?.title as string) : ""}
                      fill={true}
                    />
                  );

                  const author = post?.author
                    ? {
                        ...post?.author,
                        imageElement: (
                          <DisplayImage
                            url={post?.author?.img as string}
                            alt={
                              post?.author?.name
                                ? (post?.author?.name as string)
                                : ""
                            }
                            fill={true}
                          />
                        ),
                        linkElement: (
                          <Link
                            href={post?.author?.slug as string}
                            className="linker"
                          ></Link>
                        ),
                      }
                    : {};

                  return (
                    <Column key={`blogCard-${i}`} sm={12} md={4}>
                      <BlogCard
                        date={formatDate(post?.date as string, "DATE_SHORT")}
                        category={categoryName}
                        imageElement={imageElement}
                        title={post.title}
                        description={post.excerpt}
                        author={author}
                        linkElement={
                          <Link
                            href={post.slug as string}
                            className="linker"
                          ></Link>
                        }
                      />
                    </Column>
                  );
                }
              )
            ) : (
              <Column className="pt-5 pb-5">
                <EmptyState label={state?.dict?.common?.noResults}></EmptyState>
              </Column>
            )}
          </Suspense>
        )}
      </Row>
      <Spacer height={8} />
    </>
  );
};
export default Archive;
